// ...existing code...
import React from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Table, Tag, Descriptions, Row, Col, Collapse, Empty, Select, Image } from "antd";

const Summery = () => {
    const { id } = useParams();
    const [inspectionData, setInspectionData] = React.useState(null);
    const [userCategories, setUserCategories] = React.useState([]);
    const [selectedCategory, setSelectedCategory] = React.useState(null);

    let ImageBaseURL = "https://storage.googleapis.com/dns_storage_v2/datacollection/"

    React.useEffect(() => {
        fetchUserCategories();
    }, []);

    const fetchUserCategories = async () => {
        const headers = {
            "cache-control": "no-cache",
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
            "logged-user-email": localStorage.getItem("logged_user_email"),
            "userId": localStorage.getItem("userId")
        };
        try {
            const response = await fetch('https://dnsuatapi.eimsky.com/dataCollectionService/userPermission/getUserCategories', {
                method: 'GET',
                headers,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            const list = Array.isArray(json) ? json : [];
            setUserCategories(list || []);
            setSelectedCategory(list[0]?.category?.id || null);
        } catch (error) {
            console.error('Error fetching user categories:', error);
            setUserCategories([]);
        }
    }

    React.useEffect(() => {
        if (selectedCategory) {
            const fetchCategoryData = async () => {
                const headers = {
                    "cache-control": "no-cache",
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    "logged-user-email": localStorage.getItem("logged_user_email"),
                    "userId": localStorage.getItem("userId")
                };
                let url = `https://dnsuatapi.eimsky.com/dataCollectionService/view/getDataCollectionVisitCategoryByVisitIdAndCategoryId?categoryId=${selectedCategory}&routingVisitId=${id}`;
                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        headers,
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const json = await response.json();
                    setInspectionData(json || null);
                    console.log('Category Data:', json);
                } catch (error) {
                    console.error('Error fetching category data:', error);
                    setInspectionData(null);
                }
            };
            fetchCategoryData();
        }
    }, [selectedCategory, id]);


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">
                                    <span className="textStyles-small" style={{ fontSize: 16 }}>Inspection Summery</span>
                                </h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Branch Inspections</span>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Inspection Summary</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                            <div className="col-auto align-self-center">
                                <Select
                                    placeholder="Select Category"
                                    className='borderedSelect'
                                    bordered={false}
                                    style={{ height: 38, width: '250px' }}
                                    value={selectedCategory}
                                    onChange={(value) => setSelectedCategory(value)}
                                >
                                    {
                                        userCategories.map((cat) => (
                                            <Select.Option key={cat.id} value={cat?.category?.id} className="textStyles-small" style={{ fontSize: 12 }}>
                                                {cat?.category?.categoryName}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                !inspectionData ? (
                    <Empty
                        size="large"
                        style={{ marginTop: 50 }}
                        description={<span className="textStyles-small">No Inspection Data Available</span>} />
                ) : (
                    <>
                        <Descriptions
                            colon={false}
                            bordered size="small" column={2} style={{ marginBottom: 24, marginTop: 24 }}>
                            <Descriptions.Item
                                label={<span className="textStyles-small">Inspection ID</span>}
                            >
                                <span className="textStyles-small">
                                    {inspectionData?.id ?? 'N/A'}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={<span className="textStyles-small">Branch Name</span>}
                            >
                                <span className="textStyles-small">
                                    {inspectionData?.siteName ?? 'N/A'}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={<span className="textStyles-small">Conducted By</span>}
                            >
                                <span className="textStyles-small">
                                    {inspectionData?.userName ?? 'N/A'}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={<span className="textStyles-small">Inspection Type</span>}
                            >
                                <span className="textStyles-small">
                                    {inspectionData?.type ?? 'N/A'}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={<span className="textStyles-small">Status ID</span>}
                            >
                                <span className="textStyles-small">
                                    {inspectionData?.statusId ?? 'N/A'}
                                </span>
                            </Descriptions.Item>
                        </Descriptions>

                        <Collapse
                            ghost={true}
                            accordion>
                            {
                                inspectionData?.checklists?.map((section) => (
                                    <Collapse.Panel
                                        header={<section className="textStyles-small" style={{ fontSize: 14 }}>{section.sectionName ?? 'Section'}</section>}
                                        key={section.sectionId}>
                                        {
                                            (section.item || []).map((item, idx) => (
                                                <div key={item.id ?? idx} style={{ marginBottom: 16 }}>
                                                    <Descriptions bordered size="small" column={2}>
                                                        {
                                                            (item.checklist || []).map((c) => (
                                                                <Descriptions.Item
                                                                    key={c.id ?? c.name}
                                                                    label={<span className="textStyles-small">{c.name ?? 'Question'}</span>}
                                                                >
                                                                    <span className="textStyles-small">
                                                                        {c?.dataType === 'IMAGE' ? (
                                                                            c?.answer ? (
                                                                                <Image
                                                                                    style={{ borderRadius: 5 }}
                                                                                    src={ImageBaseURL + c.answer} alt={c.name} width={50} height={50} />
                                                                            ) : (
                                                                                'Image Not Attached Yet'
                                                                            )
                                                                        ) : (
                                                                            c.answer ?? 'Not Answer Yet'
                                                                        )}
                                                                    </span>
                                                                </Descriptions.Item>
                                                            ))
                                                        }
                                                    </Descriptions>
                                                </div>
                                            ))
                                        }
                                    </Collapse.Panel>
                                ))
                            }
                        </Collapse>
                    </>
                )
            }
        </div>
    );
};

export default Summery;
